import { Box } from '@material-ui/core';

import usePortfolio from '~/pages/Portfolio/usePortfolio';
import useSimulationRules from '~/pages/Portfolio/useSimulationRules';

import useFilteredPeriods from '../../hooks/useFilteredPeriods';
import { TableSection, TablePeriod, TableSectionProps } from '../Table';
import { useSimulationTable } from '../withSimulationTable';
import useStyles from './styles';

const SimulationSection: React.ComponentType<TableSectionProps> = ({ children, ...props }) => {
  const { expandedPeriods } = usePortfolio();
  const { simulationPeriods } = useSimulationTable();
  const { isPortfolio } = useSimulationRules();
  const filteredPeriods = useFilteredPeriods(simulationPeriods, isPortfolio);
  const { periodWrapper, section } = useStyles();

  return (
    <TableSection
      gridTemplateColumns={`200px repeat(${filteredPeriods?.length}, 138px) max-content`}
      flexWrap="nowrap"
      position="sticky"
      zIndex="banner"
      top="0"
      className={section}
      {...props}
    >
      {children}
      {filteredPeriods?.map(({ period }) => {
        const isMonthly = period.includes('-');
        const year = isMonthly ? period.split('-')[0] : period;
        const isYearExpanded = expandedPeriods.includes(year);

        return (
          <Box key={period} className={periodWrapper}>
            <TablePeriod dedupe={!isMonthly && isYearExpanded}>{period}</TablePeriod>
          </Box>
        );
      })}
    </TableSection>
  );
};

export default SimulationSection;
